<template>
<div v-infinite-scroll="moreReflections" infinite-scroll-disabled="busy" infinite-scroll-distance="700" >
  <div  v-for="pulseSurvey in pulseSurveys" :key="pulseSurvey.id">
    <div class="card card--transparent small-top">
      <div class="card--container flex" style="position: relative">
        <div class="top-right">{{formatDate(pulseSurvey.completed_at)}}</div>
        <div class="small-top" v-for="answer in pulseSurvey.answers" :key="answer.id">
          <span>{{answer.question_text}}: {{answer.answer}}</span>
        </div>
        <div class="small-top">{{pulseSurvey.open_ended_question}}</div>
        <div class="small-top">"{{pulseSurvey.reflection}}"</div>
        <div>-- {{pulseSurvey.full_name}}</div>
      </div>
    </div>
  </div>
  <div v-if="busy" class="small-top">Loading...</div>
</div> 
</template>
<script>
import Paginator from "@/services/api/paginator";
import moment from "moment";

export default {
  props: ['cohort', 'term', 'date'],
  data() {
    return {
      pulseSurveys: [],
      busy: false,
    };
  },
  mounted() {
    this.setPaginator();
    this.moreReflections();
  },
  methods: {
    setPaginator() {
      let opts = {
        'user__clientcohorts__cohort': this.cohort,
      };
      if (this.term) {
        opts.search = this.term;
      }
      if (this.date) {
        opts.completed_at = this.date;
      }
      this.pulseSurveys = [];
      this.paginator = new Paginator('CoachClientPulseSurveys', opts, 15);
    },
    moreReflections() {
      if (this.paginator.finished || this.busy) {
        return;
      }
      this.busy = true;

      this.paginator.next()
        .then(pulseSurveys => {
          this.pulseSurveys = [...this.pulseSurveys, ...pulseSurveys];
          this.busy = false;
        })
    },
    formatDate(date) {
      return moment(date).format("MMM D, YYYY");
    },
  },
  watch: {
    term() {
      this.setPaginator();
      this.moreReflections();
    },
    date() {
      this.setPaginator();
      this.moreReflections();
    }
  }
}
</script>